import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Team, Banner, Pricing, GetQuote, ProjectSection, Partners, Skills } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <Skills /> {/* Skills section */}
      <ProjectSection /> {/* Projects Section */}
      <Banner /> {/* Banner Section */}
      <Pricing /> {/* Pricing section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <GetQuote /> {/* Get Quote section */}
      <Blogs /> {/* Latest blog posts */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Partners /> {/* Partners Slider */}
    </div>
  )

}

export default HomePage;